export default "__VITE_ASSET__CKMq8w1$__"